// Apuseni E-MTB Escape 2027 — structural data only. Copy lives in /src/i18n/holidays/*.json
// All photos are real Apuseni Active photographs, optimised to WebP in /public/images/holidays.

export const HOLIDAYS_PATH = "/apuseni-emtb-holidays-romania";
export const ENQUIRY_ID = "enquiry";
export const TERMS_PATH = "/booking-terms";

const IMG = "/images/holidays";

export const HOLIDAY_IMAGES = {
  hero: `${IMG}/hero-ridge.webp`,
  intro: `${IMG}/riders-trail.webp`,
  riding: {
    berm: `${IMG}/rider-forest-berm.webp`,
    climb: `${IMG}/rider-rocky-climb.webp`,
    viewpoint: `${IMG}/rider-viewpoint.webp`,
    group: `${IMG}/group-forest-road.webp`,
    panorama: `${IMG}/panorama.webp`,
    track: `${IMG}/track-meadow.webp`,
  },
  bike: {
    rocks: `${IMG}/levo-rocks.webp`,
    track: `${IMG}/bikes-track.webp`,
    sunset: `${IMG}/handlebar-sunset.webp`,
  },
  stay: {
    front: `${IMG}/stay-front.webp`,
    garden: `${IMG}/stay-garden.webp`,
    lawn: `${IMG}/stay-lawn.webp`,
    handlebar: `${IMG}/stay-handlebar.webp`,
    terrace: `${IMG}/stay-terrace.webp`,
    room: `${IMG}/stay-room.webp`,
    dining: `${IMG}/stay-dining.webp`,
  },
  more: {
    hutView: `${IMG}/hut-table-view.webp`,
    hutLangosi: `${IMG}/hut-langosi.webp`,
    hutMeal: `${IMG}/hut-meal.webp`,
    hutBread: `${IMG}/hut-bread-cheese.webp`,
    hutPolenta: `${IMG}/hut-polenta.webp`,
    terrace: `${IMG}/stay-terrace.webp`,
  },
  season: `${IMG}/meadow-pines.webp`,
  private: `${IMG}/bikes-track.webp`,
  final: `${IMG}/panorama.webp`,
};

// Package structure. `price` = STANDARD 2027 public retail price (EUR, per person).
// `earlyBird` = limited launch promotion (first 4 direct bookings in total) — shown only in the Early Bird section.
export const HOLIDAY_PACKAGES = [
  { key: "p3", nights: 2, days: 3, price: 500, earlyBird: 400, featured: false },
  { key: "p5", nights: 4, days: 5, price: 900, earlyBird: 750, featured: false },
  { key: "p7", nights: 6, days: 7, price: 1250, earlyBird: 1000, featured: true, ridingDays: 5 },
];

export const COMPANION_PACKAGES = [
  { key: "p3", price: 250, earlyBird: 200 },
  { key: "p5", price: 450, earlyBird: 350 },
  { key: "p7", price: 650, earlyBird: 550 },
];

export const EARLY_BIRD_TOTAL_BOOKINGS = 4;

// Final approved B2B PDF. Set to null to hide the download button.
// Confidential trade document — NOT publicly downloadable. File kept internally at /app/private_docs. Keep null.
export const B2B_PDF_URL = null;

// ---- 2027 departures (static — edit `seatsLeft` as bookings are confirmed) ----
// Weekly Monday→Sunday 7-day departures; the FIRST week of each month is a pause week.
// `seats` = group capacity, `seatsLeft` = seats still available.
// A departure is "guaranteed" once (seats - seatsLeft) >= GUARANTEE_MIN riders.
export const GUARANTEE_MIN = 4;
export const LAST_SEATS_THRESHOLD = 3;

const dep = (start, end, seatsLeft = 10) => ({ id: start, start, end, pkg: "p7", seats: 10, seatsLeft });

export const DEPARTURES_2027 = [
  // pause 31 May – 6 Jun
  dep("2027-06-07", "2027-06-13"),
  dep("2027-06-14", "2027-06-20"),
  dep("2027-06-21", "2027-06-27"),
  dep("2027-06-28", "2027-07-04"),
  // pause 5 – 11 Jul
  dep("2027-07-12", "2027-07-18"),
  dep("2027-07-19", "2027-07-25"),
  dep("2027-07-26", "2027-08-01"),
  // pause 2 – 8 Aug
  dep("2027-08-09", "2027-08-15"),
  dep("2027-08-16", "2027-08-22"),
  dep("2027-08-23", "2027-08-29"),
  dep("2027-08-30", "2027-09-05"),
  // pause 6 – 12 Sep
  dep("2027-09-13", "2027-09-19"),
  dep("2027-09-20", "2027-09-26"),
  dep("2027-09-27", "2027-10-03"),
];

export function departureStatus(d) {
  if (d.seatsLeft <= 0) return "full";
  if (d.seatsLeft <= LAST_SEATS_THRESHOLD) return "last";
  return "available";
}
export const isGuaranteed = (d) => d.seats - d.seatsLeft >= GUARANTEE_MIN;

export function formatDepartureRange(d, lang = "en") {
  const loc = { ro: "ro-RO", en: "en-GB", de: "de-DE", hu: "hu-HU" }[lang] || "en-GB";
  const s = new Date(d.start + "T00:00:00");
  const e = new Date(d.end + "T00:00:00");
  const day = (x) => new Intl.DateTimeFormat(loc, { day: "numeric" }).format(x);
  const monthYear = (x) => new Intl.DateTimeFormat(loc, { month: "long", year: "numeric" }).format(x);
  if (s.getMonth() === e.getMonth()) return `${day(s)} – ${day(e)} ${monthYear(e)}`;
  const dm = (x) => new Intl.DateTimeFormat(loc, { day: "numeric", month: "short" }).format(x);
  return `${dm(s)} – ${dm(e)} ${e.getFullYear()}`;
}
